/**
 * PAYMENT ROUTES
 */

export default [
  {
    path: '/:lang?/subscribe/payment',
    name: 'subscribe-payment',
    component: () => import('@/views/subscribe/SubscribePayment.vue'),
  },
  {
    path: '/:lang?/subscribe/success',
    name: 'subscribe-success',
    component: () => import('@/views/subscribe/SubscribeSuccess.vue'),
  },
];
